
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function(){
console.log(1)


  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }


  const commonConfig = {
  itemSelectText: 'Выбрать',
  searchPlaceholderValue: 'Поиск...',
  noResultsText: 'Не найдено...',
  searchEnabled: false
};
const selectors = [
  { selector: '.f-brand', options: { searchEnabled: false } },
  { selector: '.f-model', options: { searchEnabled: false } },
   { selector: '.f-year' },
];  


const choicesInstances = {};


  selectors.forEach(({ selector, options = {} }) => {
    const element = document.querySelector(selector);
    if (element) {
      choicesInstances[selector] = new Choices(element, { 
        ...commonConfig, 
        ...options 
      });
    }
  });



const brandElement = document.querySelector('.f-brand');
    brandElement.addEventListener('change', debounce(async (e) => {
      const brandId = e.detail.value;
      const modelChoices = choicesInstances['.f-model'];
      modelChoices.removeActiveItems();
    // modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);

      try {
        const response = await fetch(`/api/models?brand_id=${brandId}`);
        const models = await response.json();
        if (models.data.length > 0) {
          modelChoices.setChoices(
            models.data.map(model => ({
              value: model.id,
              label: model.title
            })),
            'value',
            'label',
            true
          );
        } else {
          modelChoices.setChoices([{ value: '', label: 'Нет моделей для этого бренда', disabled: true }]);
        }
      } catch (error) {
        console.error('Error loading models:', error);
        modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);
      }
    }));


  if (choicesInstances['.f-model']) {
    choicesInstances['.f-model'].setChoices(
      [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
      'value',
      'label',
      true
    );
  }


const modelElement = document.querySelector('.f-model');

     const swiperWrapper = document.querySelector('.swiper-wrapper');
     const swiperButtons = document.querySelector('.swiper-buttons');
  modelElement.addEventListener('change', debounce(async (e) => {
      const modelId = e.detail.value;


  try {
    swiperWrapper.innerHTML = '<div class="loading">Загрузка...</div>';
  const response = await fetch(`/api/get-cars-by-model-id`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ modelId }),
  });

  if (!response.ok) {
    const errorText = await response.text(); // Читаем текст ошибки
    throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
  }

  const models = await response.json(); // Парсим JSON только если ответ успешный
  if (models.data.length > 0) {
      swiperButtons.style.opacity = 1;
  // Контейнер слайдов
      swiperWrapper.innerHTML = '';
            models.data.forEach((car) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = `
          <div class="car-card">
            <img src="/iwebp/${car.id}/${car.first_photo}-sm.webp" alt="${car.title}">
            <div class="car-card-title">${car.brandTitle} ${car.model} ${car.modification}, лот № ${car.id}</div>
            <div class="car-card-price"> ${car.discount_price} ₽</div>
            <p> ${car.year} г., Пробег: ${car.mileage} км</p>
            <p>${car.modification}, ${car.transmission}, ${car.drive} </p>
            <p class="hidden current-trade-in">${car.all_prices.formated.tradein}</p>
            <p class="hidden current-credit">${car.all_prices.formated.credit}</p>
          </div>
        `;
        swiperWrapper.appendChild(slide);
          addFirstActiveCar();




      });

        if (window.carSwiper) {
        window.carSwiper.update(); // Если Swiper уже есть
      } else {
        window.carSwiper = new Swiper('.credit-swiper', {
                loop: false,
            slidesPerView: 3,
            spaceBetween: 30,
  on: {
    activeIndexChange: function () {
      updateActiveCarCard(this.activeIndex);
    },
  },
          pagination: { el: '.swiper-pagination' },
          navigation: { nextEl: '.swiper-button-n', prevEl: '.swiper-button-p' },
                                               breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
      768: {
      slidesPerView: 3,
    },
  },
        });
      }


  } else {
    // Нет данных
  }
} catch (error) {
  console.error('Error:', error);
  // Показываем пользователю ошибку
}
    }));

function addFirstActiveCar() {
      const cars = document.querySelector('.swiper-cont').querySelectorAll('.car-card');
      cars[0].click();
}

const userPriceInput = document.querySelector('input[name="user_price"]');

userPriceInput.addEventListener('input',()=> {

  updateUserPriceOnline();
})


function updateUserPriceOnline() {
const activeCar = document.querySelector('.swiper-cont').querySelector('.active');
if (activeCar) {
 activeCar.click();
}
else {
        let userPrice = document.querySelector('input[name="user_price"]').value;
        userPrice = returnOnlyNumbers(userPrice);
          const outputUserPrice = document.querySelector('.t-user-price');
 outputUserPrice.textContent =formatPrice(userPrice) + ' ₽';

}

// console.log(activeCar);

}





function returnOnlyNumbers(string) {
    const clearString = String(string).replace(/\D/g, '');
    const numeric = parseInt(clearString) || 0;
    return numeric;
}


document.querySelector('.swiper-cont').addEventListener('click', function(event) {
      if (event.target.closest('.car-card')) {
          const cards = document.querySelectorAll('.car-card');
          cards.forEach(ctx => {
            ctx.classList.remove('active');

          })


        event.target.closest('.car-card').classList.toggle('active');
        let price = event.target.closest('.car-card').querySelector('.car-card-price').textContent;
        let userPrice = document.querySelector('input[name="user_price"]').value;
        price =  returnOnlyNumbers(price);
        userPrice = returnOnlyNumbers(userPrice);
       

        const currentTradein = document.querySelector('.current-trade-in').textContent;
        const currentCredit = document.querySelector('.current-credit').textContent;

         const outputTrade = document.querySelector('.t-tradein');
         const outputCredit = document.querySelector('.t-credit');
         const outputUserPrice = document.querySelector('.t-user-price');
         const outputTotal = document.querySelector('.t-total');

          outputTrade.textContent = currentTradein + ' ₽';
          outputCredit.textContent = currentCredit + ' ₽';
          outputUserPrice.textContent =formatPrice(userPrice) + ' ₽';

      
          if (price < userPrice) {
             outputTotal.textContent = 0 + ' ₽';
          }
          else {
             outputTotal.textContent = price - userPrice + ' ₽';
                     animateValueChange(outputTotal, formatPrice(price - userPrice) + ' ₽');
          }

         

 
    }
    
   
});




  function animateValueChange(element, newValue) {
    element.classList.add('value-change');
    element.textContent = newValue;
    element.addEventListener('animationend', () => {
      element.classList.remove('value-change');
    }, {once: true});
  }
function formatPrice(price) {
    return Number(price).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
        useGrouping: true
    }).replace(/,/g, ' ');
}



function updateActiveCarCard(activeIndex) {
  // Убираем активный класс у всех карточек
  document.querySelectorAll('.credit-swiper .car-card').forEach((card) => {
    card.classList.remove('active');
  });

  // Находим текущий слайд и добавляем класс его car-card
  const currentSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
  if (currentSlide) {
    const carCard = currentSlide.querySelector('.car-card');
    if (carCard) {
      carCard.classList.add('active');
      carCard.click();
    }
  }
}






});
